import React, { useState, useEffect, useRef } from "react";
import {
  Card,
  CardTitle,
  Col,
  Row,
  FormGroup,
  Input,
  Button,
  Form,
  Label,
  Spinner
} from "reactstrap";
import Select from "react-select";
import axiosInstance from "../../../middleware/axiosInstance";
import { useNavigate } from "react-router-dom";
import { RxCross2 } from "react-icons/rx";
import Swal from "sweetalert2";
import { FiArrowLeft } from 'react-icons/fi';


export default function CertificateSetting() {
  const [branches, setBranches] = useState([]);
  const navigate = useNavigate();
  const [errors, setErrors] = useState("");
  const [formData, setFormData] = useState({
    branchId: "",
    colorID: "#FB0F01",
    colorbgID: "#ffffff",
    branchColorID: "#FB0F01",
    enableSignID: false,
    IDLayout: "landscape",
    academicYearID: false,
    enableOrgLeavingCertificate: false,
    enableSignLeavingCertificate: false,
    enableDOBBonafide: false,
    enableCasteBonafide: false,
    enableCategoryBonafide: false,
    enableOrgBonafide: false,
    enableSignBonafide: false,
    enableOrgAdmissionConfirmation: false,
    enableSignAdmissionConfirmation: false,
    enableOrgCharacterCertificate: false,
    enableSignCharacterCertificate: false,
    enableOrgAttendanceCertificate: false,
    enableSignAttendanceCertificate: false,
    reasonOfLeavingLC: "",
    overAllBehaviourLC: "",
    remarkLC: "",

    enableWatermarkBonafide: false,
    enableWatermarkLeavingCertificate: false,
    enableWatermarkIdCard: false,
    enableWatermarkCharacterCertificate: false,
    enableWatermarkAttendanceCertificate: false,
    enableWatermarkAdmissionConfirmation: false,

    bonafideValue: 20,
    leavingCertificateValue: 20,
    idCardValue: 20,
    characterCertificateValue: 20,
    attendanceCertificateValue: 20,
    admissionConfirmationValue: 20,

    branchLCLogo: "",
    branchBonafideLogo: "",
    branchIdCardLogo: "",
    branchCharacterCertificateLogo: "",
    branchAttendanceCertificateLogo: "",
    branchAdmissionConfirmationLogo: "",

    isConfigLCLogo: false,
    isConfigBonafideLogo: false,
    isConfigIdCardLogo: false,
    isConfigCharacterCertificateLogo: false,
    isConfigAttendanceCertificateLogo: false,
    isConfigAdmissionConfirmationLogo: false,
  });

 const [loading, setLoading] = useState(false);

  const [isBranchLCLogoChanged, setIsBranchLCLogoChanged] = useState(false);
  const [isBranchBonafideLogoChanged, setIsBranchBonafideLogoChanged] =
    useState(false);
  const [isBranchIdCardLogoChanged, setIsBranchIdCardLogoChanged] =
    useState(false);
  const [
    isBranchCharacterCertificateLogoChanged,
    setIsBranchCharacterCertificateLogoChanged,
  ] = useState(false);
  const [
    isBranchAttendanceCertificateLogoChanged,
    setIsBranchAttendanceCertificateLogoChanged,
  ] = useState(false);
  const [
    isBranchAdmissionConfirmationLogoChanged,
    setIsBranchAdmissionConfirmationLogoChanged,
  ] = useState(false);

  const [branchLCLogoPreview, setBranchLCLogoPreview] = useState(null);
  const [branchBonafideLogoPreview, setBranchBonafideLogoPreview] =
    useState(null);
  const [branchIdCardLogoPreview, setBranchIdCardLogoPreview] = useState(null);
  const [
    branchCharacterCertificateLogoPreview,
    setBranchCharacterCertificateLogoPreview,
  ] = useState(null);
  const [
    branchAttendanceCertificateLogoPreview,
    setBranchAttendanceCertificateLogoPreview,
  ] = useState(null);
  const [
    branchAdmissionConfirmationLogoPreview,
    setBranchAdmissionConfirmationLogoPreview,
  ] = useState(null);

  // Separate configuration state for logos

  const [isConfigLCLogo, setIsConfigLCLogo] = useState(false);
  const [isConfigBonafideLogo, setIsConfigBonafideLogo] = useState(false);
  const [isConfigIdCardLogo, setIsConfigIdCardLogo] = useState(false);
  const [
    isConfigCharacterCertificateLogo,
    setIsConfigCharacterCertificateLogo,
  ] = useState(false);
  const [
    isConfigAttendanceCertificateLogo,
    setIsConfigAttendanceCertificateLogo,
  ] = useState(false);
  const [
    isConfigAdmissionConfirmationLogo,
    setIsConfigAdmissionConfirmationLogo,
  ] = useState(false);

  const [
    branchlogo,
    setBranchLogo,
  ] = useState('');

  const [fetchedLogoPreviews, setFetchedLogoPreviews] = useState({
    branchLCLogo: null,
    branchBonafideLogo: null,
    branchIdCardLogo: null,
    branchCharacterCertificateLogo: null,
    branchAttendanceCertificateLogo: null,
    branchAdmissionConfirmationLogo: null,
  });
  useEffect(() => {
    const fetchBranches = async () => {
      try {
        const response = await axiosInstance.get("/branches");
        setBranches(response.data);
      } catch (error) {
        console.error("Error fetching branches:", error);
      }
    };
    fetchBranches();
  }, []);



const handleClearFile = (name) => {

  // Reset the logo preview and formData for the specific logo
  if (name === "branchLCLogo") {
    setBranchLCLogoPreview(fetchedLogoPreviews.branchLCLogo || branchlogo || '');
    setIsConfigLCLogo(!!fetchedLogoPreviews.branchLCLogo);
    setIsBranchLCLogoChanged(false);
    setFormData((prev) => ({
      ...prev,
      branchLCLogo: null,
    }));

  }

  if (name === "branchBonafideLogo") {
    setBranchBonafideLogoPreview(fetchedLogoPreviews.branchBonafideLogo || branchlogo || '');
    setIsConfigBonafideLogo(!!fetchedLogoPreviews.branchBonafideLogo);
    setIsBranchBonafideLogoChanged(false);
    setFormData((prev) => ({
      ...prev,
      branchBonafideLogo: null,
    }));
  
  }

  if (name === "branchIdCardLogo") {
    setBranchIdCardLogoPreview(fetchedLogoPreviews.branchIdCardLogo|| branchlogo || '');
    setIsConfigIdCardLogo(!!fetchedLogoPreviews.branchIdCardLogo);
    setIsBranchIdCardLogoChanged(false);
    setFormData((prev) => ({
      ...prev,
      branchIdCardLogo: null,
    }));

  }

  if (name === "branchCharacterCertificateLogo") {
    setBranchCharacterCertificateLogoPreview(fetchedLogoPreviews.branchCharacterCertificateLogo ||branchlogo || '');
    setIsConfigCharacterCertificateLogo(!!fetchedLogoPreviews.branchCharacterCertificateLogo);
    setIsBranchCharacterCertificateLogoChanged(false);
    setFormData((prev) => ({
      ...prev,
      branchCharacterCertificateLogo: null,
    }));

  }

  if (name === "branchAttendanceCertificateLogo") {
    setBranchAttendanceCertificateLogoPreview(fetchedLogoPreviews.branchAttendanceCertificateLogo ||branchlogo || '');
    setIsConfigAttendanceCertificateLogo(!!fetchedLogoPreviews.branchAttendanceCertificateLogo);
    setIsBranchAttendanceCertificateLogoChanged(false);
    setFormData((prev) => ({
      ...prev,
      branchAttendanceCertificateLogo: null,
    }));

  }

  if (name === "branchAdmissionConfirmationLogo") {
    setBranchAdmissionConfirmationLogoPreview(fetchedLogoPreviews.branchAdmissionConfirmationLogo || branchlogo || '');
    setIsConfigAdmissionConfirmationLogo(!!fetchedLogoPreviews.branchAdmissionConfirmationLogo);
    setIsBranchAdmissionConfirmationLogoChanged(false);
    setFormData((prev) => ({
      ...prev,
      branchAdmissionConfirmationLogo: null,
    }));

  }

  // Clear the input field after clearing the logo
  const inputElement = document.getElementById(name);
  if (inputElement) {
    inputElement.value = null;
  } else {
    // console.warn(`Element with id ${name} not found`);
  }
};


  const handleImageChange = (e) => {
    const { name, files } = e.target;
    const file = files[0];

    // Object to map logo names to their corresponding state setters
    const logoPreviewSetters = {
      branchLCLogo: setBranchLCLogoPreview,
      branchBonafideLogo: setBranchBonafideLogoPreview,
      branchIdCardLogo: setBranchIdCardLogoPreview,
      branchCharacterCertificateLogo: setBranchCharacterCertificateLogoPreview,
      branchAttendanceCertificateLogo:
        setBranchAttendanceCertificateLogoPreview,
      branchAdmissionConfirmationLogo:
        setBranchAdmissionConfirmationLogoPreview,
    };

    // Object to map logo names to their corresponding change state setters
    const logoChangedSetters = {
      branchLCLogo: setIsBranchLCLogoChanged,
      branchBonafideLogo: setIsBranchBonafideLogoChanged,
      branchIdCardLogo: setIsBranchIdCardLogoChanged,
      branchCharacterCertificateLogo:
        setIsBranchCharacterCertificateLogoChanged,
      branchAttendanceCertificateLogo:
        setIsBranchAttendanceCertificateLogoChanged,
      branchAdmissionConfirmationLogo:
        setIsBranchAdmissionConfirmationLogoChanged,
    };

    if (file) {
      // Update the form data with the new file
      setFormData((prev) => ({
        ...prev,
        [name]: file,
      }));

      // Update the corresponding preview
      if (logoPreviewSetters[name]) {
        logoPreviewSetters[name](URL.createObjectURL(file));
      }

      // Set the corresponding change state to true
      if (logoChangedSetters[name]) {
        logoChangedSetters[name](true);
      }
    }
  };

  const handleCheckboxChange = (e) => {
    const { id, checked , name } = e.target;

    setFormData((prevState) => ({
      ...prevState,
      [id]: checked,
    }));

    if (!checked) {
      switch (id) {
        case "enableWatermarkIdCard":
          handleClearFile("branchIdCardLogo");
          break;
        case "enableWatermarkLeavingCertificate":
          handleClearFile("branchLCLogo")
          break;
        case "enableWatermarkBonafide":
          handleClearFile("branchBonafideLogo")
          break;
          case "enableWatermarkAdmissionConfirmation":
          handleClearFile("branchAdmissionConfirmationLogo")
            break;
            case "enableWatermarkCharacterCertificate":
          handleClearFile("branchCharacterCertificateLogo")
            break;
            case "enableWatermarkAttendanceCertificate":
          handleClearFile("branchAttendanceCertificateLogo")
            break;
        // Add more cases as needed
        default:
          break;
      }
    }
  };

  const handleInputChange = (field, value) => {
    if (
      field === "reasonOfLeavingLC" ||
      field === "overAllBehaviourLC" ||
      field === "remarkLC"
    ) {
      const words = value.trim().split(/\s+/);
      const isWordTooLong = words.some((word) => word.length > 50);
      const wordCount = words.length;

      if (isWordTooLong) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [field]: "Each word must be less than 50 characters.",
        }));
        return;
      } else if (wordCount > 40) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [field]: "Must be less than or equal to 40 words.",
        }));
        return;
      } else {
        setErrors((prevErrors) => ({ ...prevErrors, [field]: "" }));
      }
    }

    setFormData((prevState) => ({
      ...prevState,
      [field]: value,
    }));
  };

  const rangeInputRef = useRef(null);

  const handleRangeChange = (event, key) => {
    const value = event.target.value;
    setFormData((prevData) => ({
      ...prevData,
      [key]: value,
    }));
  };

  

  const fetchCertificateConfig = async (branchId) => {
    try {
      setBranchLogo('');
      const response = await axiosInstance.get("/getCertificateConfig", {
        params: { branchId },
      });

      const {
        data,
        configLCLogo,
        branchLCLogo,
        configBonafideLogo,
        configIdCardLogo,
        configCharacterCertificateLogo,
        configAttendanceCertificateLogo,
        configAdmissionConfirmationLogo,
      } = response.data;


     // Check if enableWatermarkIdCard is true, and retain previous formData if needed
    const updatedFormData = {
      ...formData,
      branchId,
      enableSignID: data?.config?.enableSignID || false,
      academicYearID: data?.config?.academicYearID || false,
      colorID: data?.config?.colorID || "#FB0F01",
      colorbgID: data?.config?.colorbgID || "#ffffff",
      branchColorID: data?.config?.branchColorID || "#FB0F01",
      IDLayout: data?.config?.IDLayout || "landscape",
      enableOrgLeavingCertificate:
        data?.config?.enableOrgLeavingCertificate || false,
      enableSignLeavingCertificate:
        data?.config?.enableSignLeavingCertificate || false,
      enableDOBBonafide: data?.config?.enableDOBBonafide || false,
      enableCasteBonafide: data?.config?.enableCasteBonafide || false,
      enableCategoryBonafide: data?.config?.enableCategoryBonafide || false,
      enableOrgBonafide: data?.config?.enableOrgBonafide || false,
      enableSignBonafide: data?.config?.enableSignBonafide || false,
      enableOrgAdmissionConfirmation:
        data?.config?.enableOrgAdmissionConfirmation || false,
      enableSignAdmissionConfirmation:
        data?.config?.enableSignAdmissionConfirmation || false,
      enableOrgCharacterCertificate:
        data?.config?.enableOrgCharacterCertificate || false,
      enableSignCharacterCertificate:
        data?.config?.enableSignCharacterCertificate || false,
      enableOrgAttendanceCertificate:
        data?.config?.enableOrgAttendanceCertificate || false,
      enableSignAttendanceCertificate:
        data?.config?.enableSignAttendanceCertificate || false,
      reasonOfLeavingLC: data?.config?.reasonOfLeavingLC || "",
      overAllBehaviourLC: data?.config?.overAllBehaviourLC || "",
      remarkLC: data?.config?.remarkLC || "",
      enableWatermarkBonafide: data?.config?.enableWatermarkBonafide || false,
      enableWatermarkLeavingCertificate:
        data?.config?.enableWatermarkLeavingCertificate || false,
      enableWatermarkIdCard: data?.config?.enableWatermarkIdCard || false,
      enableWatermarkCharacterCertificate:
        data?.config?.enableWatermarkCharacterCertificate || false,
      enableWatermarkAttendanceCertificate:
        data?.config?.enableWatermarkAttendanceCertificate || false,
      enableWatermarkAdmissionConfirmation:
        data?.config?.enableWatermarkAdmissionConfirmation || false,
      bonafideValue: data?.config?.bonafideValue || 20,
      leavingCertificateValue: data?.config?.leavingCertificateValue || 20,
      idCardValue: data?.config?.idCardValue || 20,
      attendanceCertificateValue:
        data?.config?.attendanceCertificateValue || 20,
      admissionConfirmationValue:
        data?.config?.admissionConfirmationValue || 20,
      characterCertificateValue:
        data?.config?.characterCertificateValue || 20,
        branchLCLogo: configLCLogo ||  branchLCLogo || "",
        branchBonafideLogo: configBonafideLogo||   branchLCLogo || "",
        branchIdCardLogo: configIdCardLogo||  branchLCLogo || "",
        branchCharacterCertificateLogo: configCharacterCertificateLogo || branchLCLogo ||"",
        branchAttendanceCertificateLogo: configAttendanceCertificateLogo||  branchLCLogo || "",
        branchAdmissionConfirmationLogo: configAdmissionConfirmationLogo||  branchLCLogo || "", 
    };
    setFetchedLogoPreviews({
      branchLCLogo: configLCLogo || null,
      branchBonafideLogo: configBonafideLogo || null,
      branchIdCardLogo: configIdCardLogo || null,
      branchCharacterCertificateLogo: configCharacterCertificateLogo || null,
      branchAttendanceCertificateLogo: configAttendanceCertificateLogo || null,
      branchAdmissionConfirmationLogo: configAdmissionConfirmationLogo || null,
    });
    setBranchLogo(branchLCLogo || '')
    setFormData(updatedFormData);


    
    // Update previews
    setBranchLCLogoPreview(configLCLogo || branchLCLogo || null);
    setBranchBonafideLogoPreview(configBonafideLogo || branchLCLogo || null);
    setBranchIdCardLogoPreview(configIdCardLogo || branchLCLogo || null);
    setBranchCharacterCertificateLogoPreview(configCharacterCertificateLogo || branchLCLogo || null);
    setBranchAttendanceCertificateLogoPreview(configAttendanceCertificateLogo || branchLCLogo || null);
    setBranchAdmissionConfirmationLogoPreview(configAdmissionConfirmationLogo || branchLCLogo || null);

    // Update config states
    setIsConfigLCLogo(!!configLCLogo);
    setIsConfigBonafideLogo(!!configBonafideLogo);
    setIsConfigIdCardLogo(!!configIdCardLogo);
    setIsConfigCharacterCertificateLogo(!!configCharacterCertificateLogo);
    setIsConfigAttendanceCertificateLogo(!!configAttendanceCertificateLogo);
    setIsConfigAdmissionConfirmationLogo(!!configAdmissionConfirmationLogo);

    } catch (error) {
      console.error("Error fetching certificate config:", error);
    }
  };




  useEffect(() => {
    if (formData.branchId) {
      fetchCertificateConfig(formData.branchId);
    }
  }, [formData.branchId]);

  const handleCancel = () => {
    navigate(-1);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    setLoading(true);

    const formDataToSend = new FormData();
    Object.keys(formData).forEach((key) => {
      if (formData[key]) {
        formDataToSend.append(key, formData[key]);
      }
    });

    try {
      await axiosInstance.post(`/certificateConfig`, formDataToSend, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      setFormData({
        branchId: formData.branchId,
        enableSignID: false,
        colorID: "",
        colorbgID: "",
        branchColorID: "",
        IDLayout: "",
        academicYearID: false,
        enableOrgLeavingCertificate: false,
        enableSignLeavingCertificate: false,
        enableDOBBonafide: false,
        enableCasteBonafide: false,
        enableCategoryBonafide: false,
        enableOrgBonafide: false,
        enableSignBonafide: false,
        enableWatermarkBonafide: false,

        enableOrgAdmissionConfirmation: false,
        enableSignAdmissionConfirmation: false,
        enableOrgCharacterCertificate: false,
        enableSignCharacterCertificate: false,
        enableOrgAttendanceCertificate: false,
        enableSignAttendanceCertificate: false,
        reasonOfLeavingLC: "",
        overAllBehaviourLC: "",
        remarkLC: "",
        enableWatermarkLeavingCertificate: false,
        enableWatermarkIdCard: false,
        enableWatermarkCharacterCertificate: false,
        enableWatermarkAttendanceCertificate: false,
        enableWatermarkAdmissionConfirmation: false,

        bonafideValue: "",
        leavingCertificateValue: "",
        idCardValue: "",
        characterCertificateValue: "",
        attendanceCertificateValue: "",
        admissionConfirmationValue: "",
      });

      handleClearFile("branchLCLogo");
      handleClearFile("branchBonafideLogo");
      handleClearFile("branchIdCardLogo");
      handleClearFile("branchCharacterCertificateLogo");
      handleClearFile("branchAttendanceCertificateLogo");
      handleClearFile("branchAdmissionConfirmationLogo");

      if (formData.branchId) {
        fetchCertificateConfig(formData.branchId);
      }
    } catch (error) {
      console.error("Error saving configuration:", error);
    }finally{
      setLoading(false);
    }
  };

  const handleDeleteLogo = async (logoField) => {
    // Check if the logo deletion should be skipped based on the config state
    switch (logoField) {
      case "branchLCLogo":
        if (isConfigLCLogo && branchLCLogoPreview?.startsWith("blob")) {
          // If config is true and preview is a blob (local file), just clear the file
          setFetchedLogoPreviews((prev) => ({
            ...prev,
            branchLCLogo: null,
          })); 
         handleClearFile(logoField);
          return; // Exit early
        }
        break;

      case "branchBonafideLogo":
        if (
          isConfigBonafideLogo &&
          branchBonafideLogoPreview?.startsWith("blob")
        ) {
          // If config is true and preview is a blob (local file), just clear the file
          handleClearFile(logoField);
          return; // Exit early
        }
        break;

      case "branchIdCardLogo":
        if (isConfigIdCardLogo && branchIdCardLogoPreview?.startsWith("blob")) {
          // If config is true and preview is a blob (local file), just clear the file
          handleClearFile(logoField);
          return; // Exit early
        }
        break;

      case "branchCharacterCertificateLogo":
        if (
          isConfigCharacterCertificateLogo &&
          branchCharacterCertificateLogoPreview?.startsWith("blob")
        ) {
          // If config is true and preview is a blob (local file), just clear the file
          handleClearFile(logoField);
          return; // Exit early
        }
        break;

      case "branchAttendanceCertificateLogo":
        if (
          isConfigAttendanceCertificateLogo &&
          branchAttendanceCertificateLogoPreview?.startsWith("blob")
        ) {
          // If config is true and preview is a blob (local file), just clear the file
          handleClearFile(logoField);
          return; // Exit early
        }
        break;

      case "branchAdmissionConfirmationLogo":
        if (
          isConfigAdmissionConfirmationLogo &&
          branchAdmissionConfirmationLogoPreview?.startsWith("blob")
        ) {
          // If config is true and preview is a blob (local file), just clear the file
          handleClearFile(logoField);
          return; // Exit early
        }
        break;

      default:
        break;
    }

    // If we are here, then proceed with the deletion logic (show confirmation and delete)
    Swal.fire({
      title: "Are you sure?",
      text: `Do you want to delete the logo?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          // Make the API call to delete the logo
          const response = await axiosInstance.delete(
            "/certificateConfig/deleteBranchLogo",
            {
              params: {
                branchId: formData.branchId, // Pass branchId to the API
                logoField: logoField, // Send the specific logo field name
              },
            }
          );

          // Clear the file preview (local state)
        
          // Re-fetch the certificate config to get the previous logo
          // await fetchCertificateConfig(formData.branchId, branchLCLogo);

          setFetchedLogoPreviews((prev) => ({
            ...prev,
            [logoField]: null,
          }));
      
          // Reset the formData field for the deleted logo
          setFormData((prev) => ({
            ...prev,
            [logoField]: "", 
          }));
          if (logoField === "branchLCLogo") {
            setBranchLCLogoPreview( branchlogo || '');
            setIsConfigLCLogo(false);
          }
        
          if (logoField === "branchBonafideLogo") {
            setBranchBonafideLogoPreview(branchlogo || '');
            setIsConfigBonafideLogo(false);
          }
        
          if (logoField === "branchIdCardLogo") {
            setBranchIdCardLogoPreview( branchlogo || '');
            setIsConfigIdCardLogo(false);
          }
        
          if (logoField === "branchCharacterCertificateLogo") {
            setBranchCharacterCertificateLogoPreview(branchlogo || '');
            setIsConfigCharacterCertificateLogo(false);
          }
        
          if (logoField === "branchAttendanceCertificateLogo") {
            setBranchAttendanceCertificateLogoPreview(branchlogo || '');
            setIsConfigAttendanceCertificateLogo(false);
          }
        
          if (logoField === "branchAdmissionConfirmationLogo") {
            setBranchAdmissionConfirmationLogoPreview(branchlogo || '');
            setIsConfigAdmissionConfirmationLogo(false);
          }
        } catch (error) {
          console.error(`Error deleting ${logoField}:`, error);
        }
      }
    });
  };

  const customStyles = {
    placeholder: (provided) => ({
      ...provided,
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      overflow: "hidden",
    }),
    control: (provided, state) => ({
      ...provided,
      borderColor: state.isFocused ? "#FB0F01" : provided.borderColor,
      boxShadow: state.isFocused ? "0 0 0 1px #FB0F01" : null,
      borderWidth: state.isFocused ? "0px" : "1px",
      transition: "border-color 0.2s, box-shadow 0.2s",
      "&:hover": {
        borderColor: "#FB0F01",
      },
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: "#FFFFFF",
      zIndex: 999,
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? "#FDD7C2" : "#FFFFFF",
      color: "black",
      "&:hover": {
        backgroundColor: "#FDD7C2",
        color: "black",
      },
      "&:active": {
        backgroundColor: "#E8F0FE",
      },
    }),
  };

  const handleBackClick = () => {
    navigate(-1);  
  };


  return (
    <>
    <button onClick={handleBackClick} className="floating-back-button" style={{zIndex:10}}>
            <FiArrowLeft size={24} />  
          </button>
      <div>
        <Form onSubmit={handleSubmit}>
          <Card
            style={{
              boxShadow: "none",
              marginBottom: "10px",
              borderRadius: "0",
            }}
          >
            <div
              className="d-sm-flex justify-content-between align-items-center py-sm-0 py-1 pe-3  position-relative"
              style={{ height: "" }}
            >
              <CardTitle tag="h4" className="pt-2 ps-3">
                Certificate Setting
              </CardTitle>
              <Col
                sm="6"
                lg="5"
                xl="4"
                className={`py-0  mt-2   filter-options d-flex justify-content-end  gap-2 `}
                style={{
                  paddingLeft: "15px",
                  marginBottom: "-5px",
                }}
              >
          

<FormGroup className="w-100">
  <Select
    id="branchId"
    options={branches.map((branch) => ({
      value: branch._id,
      label: branch.branchName,
    }))}
    onChange={(selected) => {
      // Check if the selected branch is different from the current one
      if (selected && selected.value !== formData.branchId) {
        // Only reset the form data if a different branch is selected
        setFormData({
          ...formData,
          branchId: selected.value,
          // Reset all watermark-related fields to false
          enableWatermarkBonafide: false,
          enableWatermarkLeavingCertificate: false,
          enableWatermarkIdCard: false,
          enableWatermarkCharacterCertificate: false,
          enableWatermarkAttendanceCertificate: false,
          enableWatermarkAdmissionConfirmation: false,
          // Reset values to their defaults (or just to 20)
          bonafideValue: 20,
          leavingCertificateValue: 20,
          idCardValue: 20,
          characterCertificateValue: 20,
          attendanceCertificateValue: 20,
          admissionConfirmationValue: 20,

          branchLCLogo: "",
          branchBonafideLogo: "",
          branchIdCardLogo: "",
          branchCharacterCertificateLogo: "",
          branchAttendanceCertificateLogo: "",
          branchAdmissionConfirmationLogo: "",


        });

        setIsBranchLCLogoChanged(false);
        setIsBranchBonafideLogoChanged(false);
        setIsBranchIdCardLogoChanged(false);
        setIsBranchCharacterCertificateLogoChanged(false);
        setIsBranchAttendanceCertificateLogoChanged(false);
        setIsBranchAdmissionConfirmationLogoChanged(false);



      } else {
        // If the same branch is selected, keep the current data unchanged
        setFormData((prevData) => ({
          ...prevData,
          branchId: selected ? selected.value : "",
        }));
      }
    }}
    value={
      branches.find((branch) => branch._id === formData.branchId)
        ? {
            value: formData.branchId,
            label: branches.find((branch) => branch._id === formData.branchId).branchName,
          }
        : null
    }
    placeholder="Select Branch"
    isSearchable={true}
    styles={customStyles}
    required
  />
</FormGroup>



              </Col>
            </div>
          </Card>
          {formData?.branchId ? 
          <Card
            className="p-4 "
            style={{
              boxShadow: "none",
              marginBottom: "10px",
              borderRadius: "0",
            }}
          >
            <Row className="py-2 ">
              <Col md="12">
                <h5 className="pb-2">ID Card:-</h5>
              </Col>

              <Col sm="6" md="6" lg="6" xl="4">
                <FormGroup>
                  <Label htmlFor="colorID">
                    <span style={{ fontWeight: "bold" }}>
                      Choose Border Color
                    </span>
                  </Label>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <input
                      type="color"
                      id="colorID"
                      value={formData.colorID || "#FB0F01"}
                      onChange={(e) =>
                        handleInputChange("colorID", e.target.value)
                      }
                      style={{ marginRight: "10px", cursor: "pointer" }}
                    />
                    <span>{formData.colorID}</span>
                  </div>
                </FormGroup>
              </Col>
              <Col sm="6" md="6" lg="6" xl="4">
                <FormGroup>
                  <label htmlFor="colorbgID">
                    <span style={{ fontWeight: "bold" }}>
                      Choose Background Color
                    </span>
                  </label>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <input
                      type="color"
                      id="colorbgID"
                      value={formData.colorbgID || "#ffffff"}
                      onChange={(e) =>
                        handleInputChange("colorbgID", e.target.value)
                      }
                      style={{ marginRight: "10px", cursor: "pointer" }}
                    />
                    <span>{formData.colorbgID}</span>
                  </div>
                </FormGroup>
              </Col>
              <Col sm="6" md="6" lg="6" xl="4">
                <FormGroup>
                  <label htmlFor="branchColorID">
                    <span style={{ fontWeight: "bold" }}>
                      Choose Branch Color
                    </span>
                  </label>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <input
                      type="color"
                      id="branchColorID"
                      value={formData.branchColorID || "#FB0F01"}
                      onChange={(e) =>
                        handleInputChange("branchColorID", e.target.value)
                      }
                      style={{ marginRight: "10px", cursor: "pointer" }}
                    />
                    <span>{formData.branchColorID}</span>
                  </div>
                </FormGroup>
              </Col>
              <Col
                sm="6"
                md="6"
                lg="6"
                xl="4"
                className=" mt-3 mt-sm-1 mt-lg-3"
              >
                <div className=" d-flex align-items-start ps-1">
                  <Input
                    type="checkbox"
                    id="enableSignID"
                    className="me-1 "
                    style={{ transform: "scale(0.9)", marginTop: "3.3px" }}
                    checked={formData.enableSignID}
                    onChange={handleCheckboxChange}
                  />
                  <Label htmlFor="enableSignID" className="me-2">
                    Enable Principal Sign
                  </Label>
                </div>
                <div className=" d-flex align-items-start ps-1">
                  <Input
                    type="checkbox"
                    id="academicYearID"
                    className="me-1 "
                    style={{ transform: "scale(0.9)", marginTop: "3.3px" }}
                    checked={formData.academicYearID}
                    onChange={handleCheckboxChange}
                  />
                  <Label htmlFor="academicYearID" className="me-2">
                    Enable Academic Year
                  </Label>
                </div>
              </Col>
              <Col sm="6" md="6" lg="6" xl="4" className=" mt-3 ">
                <label className="">
                  <strong>Type of Card Layout</strong>
                </label>
                <label className=" d-flex gap-2">
                  <Input
                    type="radio"
                    name="IDLayout"
                    value="landscape"
                    checked={formData.IDLayout === "landscape"}
                    onChange={(event) =>
                      handleInputChange("IDLayout", event.target.value)
                    }
                  />
                  Landscape
                </label>

                <label className=" d-flex gap-2">
                  <Input
                    type="radio"
                    name="IDLayout"
                    value="portrate"
                    checked={formData.IDLayout === "portrate"}
                    onChange={(event) =>
                      handleInputChange("IDLayout", event.target.value)
                    }
                  />
                  Portrate
                </label>
              </Col>
              <Col sm="6" md="6" lg="6" xl="4" className="mb-1 mt-3">
                <div className=" d-flex align-items-start  ms-1">
                  <Input
                    type="checkbox"
                    id="enableWatermarkIdCard"
                    className="me-1"
                    style={{ transform: "scale(0.9)", marginTop: "3.3px" }}
                    checked={formData.enableWatermarkIdCard}
                    onChange={handleCheckboxChange}
                  />
                  <Label htmlFor="enableWatermarkIdCard" className="me-2">
                    Enable Background Watermark
                  </Label>
                </div>

                {(formData.enableWatermarkIdCard) && (
                  <div className="range-container  ms-1">
                    <label className="me-2 ps-1">
                      <strong>Visibility:</strong>
                    </label>
                    <input
                      type="range"
                      ref={rangeInputRef}
                      min="1"
                      max="99"
                      step="1"
                      value={formData.idCardValue}
                      onChange={(e) => handleRangeChange(e, "idCardValue")}
                      disabled={!formData.enableWatermarkIdCard}
                    />
                    <div className="value">{formData.idCardValue}</div>

                  
                  </div>
                )}
              </Col>
              {(formData.enableWatermarkIdCard ||
                formData.branchIdCardLogo == !branchlogo) && (
                <>
                  {branchIdCardLogoPreview && (
                    <Col sm="6" md="6" lg="6" xl="4" className="mb-1">
                      <div className="d-flex flex-column align-items-start mt-0 mb-3 mb-md-0">
                        <Label>
                          <span style={{ fontWeight: "bold" }}>Preview:</span>
                        </Label>
                        <div
                          style={{
                            position: "relative",
                            display: "inline-block",
                          }}
                        >
                          <img
                            src={branchIdCardLogoPreview}
                            alt="Branch Preview"
                            style={{
                              width: "200px",
                              height: "80px",
                              objectFit: "contain",
                              opacity: formData.enableWatermarkIdCard
                                ? formData.idCardValue / 100
                                : 1,
                              transition: "opacity 0.3s ease-in-out",
                            }}
                          />

                          {isConfigIdCardLogo && (
                            <RxCross2
                              onClick={() =>
                                handleDeleteLogo("branchIdCardLogo")
                              }
                              style={{
                                position: "absolute",
                                top: "7px",
                                right: "8px",
                                cursor: "pointer",
                                color: "red",
                                fontSize: "20px",
                                backgroundColor: "#ffffff",
                              }}
                            />
                          )}
                        </div>
                      </div>
                    </Col>
                  )}

                  <Col sm="6" md="6" lg="6" xl="4" className="mb-1">
                    <FormGroup>
                      <Label for="branchIdCardLogo">
                        <span style={{ fontWeight: "bold" }}>Change Logo</span>
                      </Label>
                      <div
                        style={{
                          position: "relative",
                          display: "inline-block",
                          width: "100%",
                        }}
                      >
                        {isBranchIdCardLogoChanged && (
                          <RxCross2
                            onClick={() => handleClearFile("branchIdCardLogo")}
                            style={{
                              position: "absolute",
                              top: "10px",
                              right: "8px",
                              cursor: "pointer",
                              color: "red",
                              fontSize: "20px",
                              backgroundColor: "#ffffff",
                            }}
                          />
                        )}
                        <div className="d-flex align-items-center">
                          <Input
                            type="file"
                            name="branchIdCardLogo"
                            id="branchIdCardLogo"
                            style={{ width: "100%" }}
                            onChange={handleImageChange}
                          />
                        </div>
                        <span style={{ fontSize: "12px", color: "#d83030" }}>
                          Maximum Upload Limit: 5MB
                        </span>
                      </div>
                    </FormGroup>
                  </Col>
                </>
              )}
            </Row>
            <hr className="m-0 p-0"></hr>
            <Row className="py-2 pt-3">
              <Col md="12">
                <h5 className="pb-2">Leaving Certificate:-</h5>
              </Col>
              <Col sm="6" md="6" lg="6" xl="4" className=" ">
                <div className="align-items-start ps-0 pb-2">
                  <label className="me-2 ps-1 pb-1">
                    <strong>Reason Of Leaving</strong>
                  </label>
                  <Input
                    type="text"
                    id="reasonOfLeavingLC"
                    placeholder="Enter Reason Here..."
                    value={formData.reasonOfLeavingLC}
                    onChange={(event) =>
                      handleInputChange("reasonOfLeavingLC", event.target.value)
                    }
                  />
                  {errors.reasonOfLeavingLC && (
                    <div style={{ color: "red", fontSize: "0.9rem" }}>
                      {errors.reasonOfLeavingLC}
                    </div>
                  )}
                </div>
              </Col>
              <Col sm="6" md="6" lg="6" xl="4">
                <div className="align-items-start ps-0 pb-1">
                  <label className="me-2 ps-1 pb-1">
                    <strong>All Over Behaviour</strong>
                  </label>
                  <Input
                    type="text"
                    id="overAllBehaviourLC"
                    placeholder="Enter Behaviour Here..."
                    value={formData.overAllBehaviourLC}
                    onChange={(event) =>
                      handleInputChange(
                        "overAllBehaviourLC",
                        event.target.value
                      )
                    }
                  />
                  {errors.overAllBehaviourLC && (
                    <div style={{ color: "red", fontSize: "0.9rem" }}>
                      {errors.overAllBehaviourLC}
                    </div>
                  )}
                </div>
              </Col>
              <Col sm="6" md="6" lg="6" xl="4">
                <div className="align-items-start ps-0 pb-1">
                  <label className="me-2 ps-1 pb-1">
                    <strong>Remark</strong>
                  </label>
                  <Input
                    type="text"
                    id="remarkLC"
                    placeholder="Enter Remark Here..."
                    value={formData.remarkLC}
                    onChange={(event) =>
                      handleInputChange("remarkLC", event.target.value)
                    }
                  />
                  {errors.remarkLC && (
                    <div style={{ color: "red", fontSize: "0.9rem" }}>
                      {errors.remarkLC}
                    </div>
                  )}
                </div>
              </Col>
              <Col sm="6" md="6" lg="6" xl="4" className="mt-3">
                <div className=" d-flex align-items-start  ms-1">
                  <Input
                    type="checkbox"
                    id="enableSignLeavingCertificate"
                    className="me-1  "
                    style={{ transform: "scale(0.9)", marginTop: "3.3px" }}
                    checked={formData.enableSignLeavingCertificate}
                    onChange={handleCheckboxChange}
                  />
                  <Label htmlFor="enableSignLeavingCertificate" className="me-2 ">
                    Enable Principal Sign
                  </Label>
                </div>
              </Col>
              <Col sm="6" md="6" lg="6" xl="4" className="mt-3">
                <div className=" d-flex align-items-start  ms-1">
                  <Input
                    type="checkbox"
                    id="enableOrgLeavingCertificate"
                    className="me-1 "
                    style={{ transform: "scale(0.9)", marginTop: "3.3px" }}
                    checked={formData.enableOrgLeavingCertificate}
                    onChange={handleCheckboxChange}
                  />
                  <Label htmlFor="enableOrgLeavingCertificate" className="me-2">
                    Enable Organization Name
                  </Label>
                </div>
              </Col>
              <Col sm="6" md="6" lg="6" xl="4" className="mt-3">
                <div className=" d-flex align-items-start ms-1">
                  <Input
                    type="checkbox"
                    id="enableWatermarkLeavingCertificate"
                    className="me-1"
                    style={{ transform: "scale(0.9)", marginTop: "3.3px" }}
                    checked={formData.enableWatermarkLeavingCertificate}
                    onChange={handleCheckboxChange}
                  />
                  <Label
                    htmlFor="enableWatermarkLeavingCertificate"
                    className="me-2"
                  >
                    Enable Background Watermark
                  </Label>
                </div>
                {(formData.enableWatermarkLeavingCertificate) && (
                  <div className="range-container  ms-1">
                    <label className="me-2 ps-1">
                      <strong>Visibility:</strong>
                    </label>
                    <input
                      type="range"
                      ref={rangeInputRef}
                      min="1"
                      max="99"
                      step="1"
                      value={formData.leavingCertificateValue}
                      onChange={(e) =>
                        handleRangeChange(e, "leavingCertificateValue")
                      }
                      disabled={!formData.enableWatermarkLeavingCertificate}
                    />
                    <div className="value">
                      {formData.leavingCertificateValue}
                    </div>

                  
                  </div>
                )}
              </Col>
              {(formData.enableWatermarkLeavingCertificate ||
                formData.branchLCLogo == !branchlogo) && (
                <>
                  {branchLCLogoPreview && (
                    <Col sm="6" md="6" lg="6" xl="4" className="mb-1">
                      <div className="d-flex flex-column align-items-start mt-0 mb-3 mb-md-0">
                        <Label>
                          <span style={{ fontWeight: "bold" }}>Preview:</span>
                        </Label>
                        <div
                          style={{
                            position: "relative",
                            display: "inline-block",
                          }}
                        >
                          <img
                            src={branchLCLogoPreview}
                            alt="Branch Preview"
                            style={{
                              width: "200px",
                              height: "80px",
                              objectFit: "contain",
                              opacity:
                                formData.enableWatermarkLeavingCertificate
                                  ? formData.leavingCertificateValue / 100
                                  : 1,
                              transition: "opacity 0.3s ease-in-out",
                            }}
                          />

                          {isConfigLCLogo && (
                            <RxCross2
                              onClick={() => handleDeleteLogo("branchLCLogo")}
                              style={{
                                position: "absolute",
                                top: "7px",
                                right: "8px",
                                cursor: "pointer",
                                color: "red",
                                fontSize: "20px",
                                backgroundColor: "#ffffff",
                              }}
                            />
                          )}
                        </div>
                      </div>
                    </Col>
                  )}

                  <Col sm="6" md="6" lg="6" xl="4" className="mb-1">
                    <FormGroup>
                      <Label for="branchLCLogo">
                        <span style={{ fontWeight: "bold" }}>Change Logo</span>
                      </Label>
                      <div
                        style={{
                          position: "relative",
                          display: "inline-block",
                          width: "100%",
                        }}
                      >
                        {isBranchLCLogoChanged && (
                          <RxCross2
                            onClick={() => handleClearFile("branchLCLogo")}
                            style={{
                              position: "absolute",
                              top: "10px",
                              right: "8px",
                              cursor: "pointer",
                              color: "red",
                              fontSize: "20px",
                              backgroundColor: "#ffffff",
                            }}
                          />
                        )}
                        <div className="d-flex align-items-center">
                          <Input
                            type="file"
                            name="branchLCLogo"
                            id="branchLCLogo"
                            style={{ width: "100%" }}
                            onChange={handleImageChange}
                          />
                        </div>
                        <span style={{ fontSize: "12px", color: "#d83030" }}>
                          Maximum Upload Limit: 5MB
                        </span>
                      </div>
                    </FormGroup>
                  </Col>
                </>
              )}
            </Row>
            <hr className=" m-0 p-0"></hr>
            <Row className="py-2 pt-3">
              <Col md="12">
                <h5 className="pb-2">Bonafide Certificate:-</h5>
              </Col>
              <Col sm="6" md="6" lg="6" xl="4" className="mb-1">
                <div className="d-flex align-items-start ps-1">
                  <Input
                    type="checkbox"
                    id="enableDOBBonafide"
                    className="me-1"
                    style={{ transform: "scale(0.9)", marginTop: "3.3px" }}
                    checked={formData.enableDOBBonafide}
                    onChange={handleCheckboxChange}
                  />
                  <Label htmlFor="enableDOBBonafide" className="me-2">
                    Enable Date Of Birth
                  </Label>
                </div>
              </Col>

              <Col sm="6" md="6" lg="6" xl="4" className="mb-1">
                <div className="d-flex align-items-start ps-1">
                  <Input
                    type="checkbox"
                    id="enableCasteBonafide"
                    className="me-1"
                    style={{ transform: "scale(0.9)", marginTop: "3.3px" }}
                    checked={formData.enableCasteBonafide}
                    onChange={handleCheckboxChange}
                  />
                  <Label htmlFor="enableCasteBonafide" className="me-2">
                    Enable Caste
                  </Label>
                </div>
              </Col>

              <Col sm="6" md="6" lg="6" xl="4" className="mb-1">
                <div className="d-flex align-items-start ps-1">
                  <Input
                    type="checkbox"
                    id="enableCategoryBonafide"
                    className="me-1"
                    style={{ transform: "scale(0.9)", marginTop: "3.3px" }}
                    checked={formData.enableCategoryBonafide}
                    onChange={handleCheckboxChange}
                  />
                  <Label htmlFor="enableCategoryBonafide" className="me-2">
                    Enable Category
                  </Label>
                </div>
              </Col>
              <Col sm="6" md="6" lg="6" xl="4" className="mb-1">
                <div className="d-flex align-items-start ps-1">
                  <Input
                    type="checkbox"
                    id="enableSignBonafide"
                    className="me-1"
                    style={{ transform: "scale(0.9)", marginTop: "3.3px" }}
                    checked={formData.enableSignBonafide}
                    onChange={handleCheckboxChange}
                  />
                  <Label htmlFor="enableSignBonafide" className="me-2">
                    Enable Principal Sign
                  </Label>
                </div>
              </Col>
              <Col sm="6" md="6" lg="6" xl="4" className="mb-1">
                <div className="d-flex align-items-start ps-1">
                  <Input
                    type="checkbox"
                    id="enableOrgBonafide"
                    className="me-1"
                    style={{ transform: "scale(0.9)", marginTop: "3.3px" }}
                    checked={formData.enableOrgBonafide}
                    onChange={handleCheckboxChange}
                  />
                  <Label htmlFor="enableOrgBonafide" className="me-2">
                    Enable Organization Name
                  </Label>
                </div>
              </Col>

              <Col sm="6" md="6" lg="6" xl="4" className="mt-0">
                <div className=" d-flex align-items-start  ms-1">
                  <Input
                    type="checkbox"
                    id="enableWatermarkBonafide"
                    className="me-1"
                    style={{ transform: "scale(0.9)", marginTop: "3.3px" }}
                    checked={formData.enableWatermarkBonafide}
                    onChange={handleCheckboxChange}
                  />
                  <Label htmlFor="enableWatermarkBonafide" className="me-2">
                    Enable Background Watermark
                  </Label>
                </div>

                {(formData.enableWatermarkBonafide) && (
                  <div className="range-container  ms-1">
                    <label className="me-2 ps-1">
                      <strong>Visibility:</strong>
                    </label>
                    <input
                      type="range"
                      ref={rangeInputRef}
                      min="1"
                      max="99"
                      step="1"
                      value={formData.bonafideValue}
                      onChange={(e) => handleRangeChange(e, "bonafideValue")}
                      disabled={!formData.enableWatermarkBonafide}
                    />
                    <div className="value">{formData.bonafideValue}</div>
                  
                  </div>
                )}
              </Col>
              {(formData.enableWatermarkBonafide ||
                formData.branchBonafideLogo == !branchlogo) && (
                <>
                  {branchBonafideLogoPreview && (
                    <Col sm="6" md="6" lg="6" xl="4" className="mb-1">
                      <div className="d-flex flex-column align-items-start mt-0 mb-3 mb-md-0">
                        <Label>
                          <span style={{ fontWeight: "bold" }}>Preview:</span>
                        </Label>
                        <div
                          style={{
                            position: "relative",
                            display: "inline-block",
                          }}
                        >
                          <img
                            src={branchBonafideLogoPreview}
                            alt="Branch Preview"
                            style={{
                              width: "200px",
                              height: "80px",
                              objectFit: "contain",
                              opacity: formData.enableWatermarkBonafide
                                ? formData.bonafideValue / 100
                                : 1,
                              transition: "opacity 0.3s ease-in-out",
                            }}
                          />

                          {isConfigBonafideLogo && (
                            <RxCross2
                              onClick={() =>
                                handleDeleteLogo("branchBonafideLogo")
                              }
                              style={{
                                position: "absolute",
                                top: "7px",
                                right: "8px",
                                cursor: "pointer",
                                color: "red",
                                fontSize: "20px",
                                backgroundColor: "#ffffff",
                              }}
                            />
                          )}
                        </div>
                      </div>
                    </Col>
                  )}

                  <Col sm="6" md="6" lg="6" xl="4" className="mb-1">
                    <FormGroup>
                      <Label for="branchBonafideLogo">
                        <span style={{ fontWeight: "bold" }}>Change Logo</span>
                      </Label>
                      <div
                        style={{
                          position: "relative",
                          display: "inline-block",
                          width: "100%",
                        }}
                      >
                        {isBranchBonafideLogoChanged && (
                          <RxCross2
                            onClick={() =>
                              handleClearFile("branchBonafideLogo")
                            }
                            style={{
                              position: "absolute",
                              top: "10px",
                              right: "8px",
                              cursor: "pointer",
                              color: "red",
                              fontSize: "20px",
                              backgroundColor: "#ffffff",
                            }}
                          />
                        )}
                        <div className="d-flex align-items-center">
                          <Input
                            type="file"
                            name="branchBonafideLogo"
                            id="branchBonafideLogo"
                            style={{ width: "100%" }}
                            onChange={handleImageChange}
                          />
                        </div>
                        <span style={{ fontSize: "12px", color: "#d83030" }}>
                          Maximum Upload Limit: 5MB
                        </span>
                      </div>
                    </FormGroup>
                  </Col>
                </>
              )}
            </Row>
            <hr className=" m-0 p-0"></hr>

            <Row className="py-2 pt-3">
              <Col md="12">
                <h5 className="pb-2">Admission Confirmation:-</h5>
              </Col>
              <Col sm="6" md="6" lg="6" xl="4">
                <div className=" d-flex align-items-start  ms-1">
                  <Input
                    type="checkbox"
                    id="enableSignAdmissionConfirmation"
                    className="me-1 "
                    style={{ transform: "scale(0.9)", marginTop: "3.3px" }}
                    checked={formData.enableSignAdmissionConfirmation}
                    onChange={handleCheckboxChange}
                  />
                  <Label htmlFor="enableSignAdmissionConfirmation" className="me-2">
                    Enable Principal Sign
                  </Label>
                </div>
              </Col>
              <Col sm="6" md="6" lg="6" xl="4">
                <div className=" d-flex align-items-start ps-1">
                  <Input
                    type="checkbox"
                    id="enableOrgAdmissionConfirmation"
                    className="me-1 "
                    style={{ transform: "scale(0.9)", marginTop: "3.3px" }}
                    checked={formData.enableOrgAdmissionConfirmation}
                    onChange={handleCheckboxChange}
                  />
                  <Label htmlFor="enableOrgAdmissionConfirmation" className="me-2">
                    Enable Organization Name
                  </Label>
                </div>
              </Col>
              <Col sm="6" md="6" lg="6" xl="4" className="mt-0">
                <div className=" d-flex align-items-start  ms-1">
                  <Input
                    type="checkbox"
                    id="enableWatermarkAdmissionConfirmation"
                    className="me-1"
                    style={{ transform: "scale(0.9)", marginTop: "3.3px" }}
                    checked={formData.enableWatermarkAdmissionConfirmation}
                    onChange={handleCheckboxChange}
                  />
                  <Label
                    htmlFor="enableWatermarkAdmissionConfirmation"
                    className="me-2"
                  >
                    Enable Background Watermark
                  </Label>
                </div>

                {(formData.enableWatermarkAdmissionConfirmation) && (
                  <div className="range-container  ms-1">
                    <label className="me-2 ps-1">
                      <strong>Visibility:</strong>
                    </label>
                    <input
                      type="range"
                      ref={rangeInputRef}
                      min="1"
                      max="99"
                      step="1"
                      value={formData.admissionConfirmationValue}
                      onChange={(e) =>
                        handleRangeChange(e, "admissionConfirmationValue")
                      }
                      disabled={!formData.enableWatermarkAdmissionConfirmation}
                    />
                    <div className="value">
                      {formData.admissionConfirmationValue}
                    </div>

                  
                  </div>
                )}
              </Col>
              {(formData.enableWatermarkAdmissionConfirmation ||
                formData.branchAdmissionConfirmationLogo == !branchlogo) && (
                <>
                  {branchAdmissionConfirmationLogoPreview && (
                    <Col sm="6" md="6" lg="6" xl="4" className="mb-1">
                      <div className="d-flex flex-column align-items-start mt-0 mb-3 mb-md-0">
                        <Label>
                          <span style={{ fontWeight: "bold" }}>Preview:</span>
                        </Label>
                        <div
                          style={{
                            position: "relative",
                            display: "inline-block",
                          }}
                        >
                          <img
                            src={branchAdmissionConfirmationLogoPreview}
                            alt="Branch Preview"
                            style={{
                              width: "200px",
                              height: "80px",
                              objectFit: "contain",
                              opacity:
                                formData.enableWatermarkAdmissionConfirmation
                                  ? formData.admissionConfirmationValue / 100
                                  : 1,
                              transition: "opacity 0.3s ease-in-out",
                            }}
                          />

                          {isConfigAdmissionConfirmationLogo && (
                            <RxCross2
                              onClick={() =>
                                handleDeleteLogo(
                                  "branchAdmissionConfirmationLogo"
                                )
                              }
                              style={{
                                position: "absolute",
                                top: "10px",
                                right: "8px",
                                cursor: "pointer",
                                color: "red",
                                fontSize: "20px",
                                backgroundColor: "#ffffff",
                              }}
                            />
                          )}
                        </div>
                      </div>
                    </Col>
                  )}

                  <Col sm="6" md="6" lg="6" xl="4" className="mb-1">
                    <FormGroup>
                      <Label for="branchAdmissionConfirmationLogo">
                        <span style={{ fontWeight: "bold" }}>Change Logo</span>
                      </Label>
                      <div
                        style={{
                          position: "relative",
                          display: "inline-block",
                          width: "100%",
                        }}
                      >
                        {isBranchAdmissionConfirmationLogoChanged && (
                          <RxCross2
                            onClick={() =>
                              handleClearFile("branchAdmissionConfirmationLogo")
                            }
                            style={{
                              position: "absolute",
                              top: "10px",
                              right: "8px",
                              cursor: "pointer",
                              color: "red",
                              fontSize: "20px",
                              backgroundColor: "#ffffff",
                            }}
                          />
                        )}
                        <div className="d-flex align-items-center">
                          <Input
                            type="file"
                            name="branchAdmissionConfirmationLogo"
                            id="branchAdmissionConfirmationLogo"
                            style={{ width: "100%" }}
                            onChange={handleImageChange}
                          />
                        </div>
                        <span style={{ fontSize: "12px", color: "#d83030" }}>
                          Maximum Upload Limit: 5MB
                        </span>
                      </div>
                    </FormGroup>
                  </Col>
                </>
              )}
            </Row>
            <hr className=" m-0 p-0"></hr>

            <Row className="py-2 pt-3">
              <Col md="12">
                <h5 className="pb-2">Character Certificate:-</h5>
              </Col>

              <Col sm="6" md="6" lg="6" xl="4">
                <div className=" d-flex align-items-start  ms-1">
                  <Input
                    type="checkbox"
                    id="enableSignCharacterCertificate"
                    className="me-1 "
                    style={{ transform: "scale(0.9)", marginTop: "3.3px" }}
                    checked={formData.enableSignCharacterCertificate}
                    onChange={handleCheckboxChange}
                  />
                  <Label htmlFor="enableSignCharacterCertificate" className="me-2">
                    Enable Principal Sign
                  </Label>
                </div>
              </Col>
              <Col sm="6" md="6" lg="6" xl="4">
                <div className=" d-flex align-items-start ps-1">
                  <Input
                    type="checkbox"
                    id="enableOrgCharacterCertificate"
                    className="me-1 "
                    style={{ transform: "scale(0.9)", marginTop: "3.3px" }}
                    checked={formData.enableOrgCharacterCertificate}
                    onChange={handleCheckboxChange}
                  />
                  <Label htmlFor="enableOrgCharacterCertificate" className="me-2">
                    Enable Organization Name
                  </Label>
                </div>
              </Col>
              <Col sm="6" md="6" lg="6" xl="4" className="mt-0">
                <div className=" d-flex align-items-start  ms-1">
                  <Input
                    type="checkbox"
                    id="enableWatermarkCharacterCertificate"
                    className="me-1"
                    style={{ transform: "scale(0.9)", marginTop: "3.3px" }}
                    checked={formData.enableWatermarkCharacterCertificate}
                    onChange={handleCheckboxChange}
                  />
                  <Label
                    htmlFor="enableWatermarkCharacterCertificate"
                    className="me-2"
                  >
                    Enable Background Watermark
                  </Label>
                </div>

                {(formData.enableWatermarkCharacterCertificate) && (
                  <div className="range-container  ms-1">
                    <label className="me-2 ps-1">
                      <strong>Visibility:</strong>
                    </label>
                    <input
                      type="range"
                      ref={rangeInputRef}
                      min="1"
                      max="99"
                      step="1"
                      value={formData.characterCertificateValue}
                      onChange={(e) =>
                        handleRangeChange(e, "characterCertificateValue")
                      }
                      disabled={!formData.enableWatermarkCharacterCertificate}
                    />
                    <div className="value">
                      {formData.characterCertificateValue}
                    </div>

                   
                  </div>
                )}
              </Col>
              {(formData.enableWatermarkCharacterCertificate ||
                formData.branchCharacterCertificateLogo== !branchlogo) && (
                <>
                  {branchCharacterCertificateLogoPreview && (
                    <Col sm="6" md="6" lg="6" xl="4" className="mb-1">
                      <div className="d-flex flex-column align-items-start mt-0 mb-3 mb-md-0">
                        <Label>
                          <span style={{ fontWeight: "bold" }}>Preview:</span>
                        </Label>
                        <div
                          style={{
                            position: "relative",
                            display: "inline-block",
                          }}
                        >
                          <img
                            src={branchCharacterCertificateLogoPreview}
                            alt="Branch Preview"
                            style={{
                              width: "200px",
                              height: "80px",
                              objectFit: "contain",
                              opacity:
                                formData.enableWatermarkCharacterCertificate
                                  ? formData.characterCertificateValue / 100
                                  : 1,
                              transition: "opacity 0.3s ease-in-out",
                            }}
                          />

                          {isConfigCharacterCertificateLogo && (
                            <RxCross2
                              onClick={() =>
                                handleDeleteLogo(
                                  "branchCharacterCertificateLogo"
                                )
                              }
                              style={{
                                position: "absolute",
                                top: "7px",
                                right: "8px",
                                cursor: "pointer",
                                color: "red",
                                fontSize: "20px",
                                backgroundColor: "#ffffff",
                              }}
                            />
                          )}
                        </div>
                      </div>
                    </Col>
                  )}

                  <Col sm="6" md="6" lg="6" xl="4" className="mb-1">
                    <FormGroup>
                      <Label for="branchCharacterCertificateLogo">
                        <span style={{ fontWeight: "bold" }}>Change Logo</span>
                      </Label>
                      <div
                        style={{
                          position: "relative",
                          display: "inline-block",
                          width: "100%",
                        }}
                      >
                        {isBranchCharacterCertificateLogoChanged && (
                          <RxCross2
                            onClick={() =>
                              handleClearFile("branchCharacterCertificateLogo")
                            }
                            style={{
                              position: "absolute",
                              top: "10px",
                              right: "8px",
                              cursor: "pointer",
                              color: "red",
                              fontSize: "20px",
                              backgroundColor: "#ffffff",
                            }}
                          />
                        )}
                        <div className="d-flex align-items-center">
                          <Input
                            type="file"
                            name="branchCharacterCertificateLogo"
                            id="branchCharacterCertificateLogo"
                            style={{ width: "100%" }}
                            onChange={handleImageChange}
                          />
                        </div>
                        <span style={{ fontSize: "12px", color: "#d83030" }}>
                          Maximum Upload Limit: 5MB
                        </span>
                      </div>
                    </FormGroup>
                  </Col>
                </>
              )}
            </Row>
            <hr className=" m-0 p-0"></hr>

            <Row className="py-2 pt-3">
              <Col md="12">
                <h5 className="pb-2">Attendance Certificate:-</h5>
              </Col>
              <Col sm="6" md="6" lg="6" xl="4">
                <div className=" d-flex align-items-start ps-1">
                  <Input
                    type="checkbox"
                    id="enableOrgAttendanceCertificate"
                    className="me-1 "
                    style={{ transform: "scale(0.9)", marginTop: "3.3px" }}
                    checked={formData.enableOrgAttendanceCertificate}
                    onChange={handleCheckboxChange}
                  />
                  <Label htmlFor="enableOrgAttendanceCertificate" className="me-2">
                    Enable Organization Name
                  </Label>
                </div>
              </Col>
              <Col sm="6" md="6" lg="6" xl="4" className="mt-0">
                <div className=" d-flex align-items-start  ms-1">
                  <Input
                    type="checkbox"
                    id="enableWatermarkAttendanceCertificate"
                    className="me-1"
                    style={{ transform: "scale(0.9)", marginTop: "3.3px" }}
                    checked={formData.enableWatermarkAttendanceCertificate}
                    onChange={handleCheckboxChange}
                  />
                  <Label
                    htmlFor="enableWatermarkAttendanceCertificate"
                    className="me-2"
                  >
                    Enable Background Watermark
                  </Label>
                </div>

                {(formData.enableWatermarkAttendanceCertificate) && (
                  <div className="range-container  ms-1">
                    <label className="me-2 ps-1">
                      <strong>Visibility:</strong>
                    </label>
                    <input
                      type="range"
                      ref={rangeInputRef}
                      min="1"
                      max="99"
                      step="1"
                      value={formData.attendanceCertificateValue}
                      onChange={(e) =>
                        handleRangeChange(e, "attendanceCertificateValue")
                      }
                      disabled={!formData.enableWatermarkAttendanceCertificate}
                    />
                    <div className="value">
                      {formData.attendanceCertificateValue}
                    </div>

                    
                  </div>
                )}
              </Col>
              {(formData.enableWatermarkAttendanceCertificate ||
                formData.branchAttendanceCertificateLogo == !branchlogo) && (
                <>
                  {branchAttendanceCertificateLogoPreview && (
                    <Col sm="6" md="6" lg="6" xl="4" className="mb-1">
                      <div className="d-flex flex-column align-items-start mt-0 mb-3 mb-md-0">
                        <Label>
                          <span style={{ fontWeight: "bold" }}>Preview:</span>
                        </Label>
                        <div
                          style={{
                            position: "relative",
                            display: "inline-block",
                          }}
                        >
                          <img
                            src={branchAttendanceCertificateLogoPreview}
                            alt="Branch Preview"
                            style={{
                              width: "200px",
                              height: "80px",
                              objectFit: "contain",
                              opacity:
                                formData.enableWatermarkAttendanceCertificate
                                  ? formData.attendanceCertificateValue / 100
                                  : 1,
                              transition: "opacity 0.3s ease-in-out",
                            }}
                          />

                          {isConfigAttendanceCertificateLogo && (
                            <RxCross2
                              onClick={() =>
                                handleDeleteLogo(
                                  "branchAttendanceCertificateLogo"
                                )
                              }
                              style={{
                                position: "absolute",
                                top: "7px",
                                right: "8px",
                                cursor: "pointer",
                                color: "red",
                                fontSize: "20px",
                                backgroundColor: "#ffffff",
                              }}
                            />
                          )}
                        </div>
                      </div>
                    </Col>
                  )}

                  <Col sm="6" md="6" lg="6" xl="4" className="mb-1">
                    <FormGroup>
                      <Label for="branchAttendanceCertificateLogo">
                        <span style={{ fontWeight: "bold" }}>Change Logo</span>
                      </Label>
                      <div
                        style={{
                          position: "relative",
                          display: "inline-block",
                          width: "100%",
                        }}
                      >
                        {isBranchAttendanceCertificateLogoChanged && (
                          <RxCross2
                            onClick={() =>
                              handleClearFile("branchAttendanceCertificateLogo")
                            }
                            style={{
                              position: "absolute",
                              top: "10px",
                              right: "8px",
                              cursor: "pointer",
                              color: "red",
                              fontSize: "20px",
                              backgroundColor: "#ffffff",
                            }}
                          />
                        )}
                        <div className="d-flex align-items-center">
                          <Input
                            type="file"
                            name="branchAttendanceCertificateLogo"
                            id="branchAttendanceCertificateLogo"
                            style={{ width: "100%" }}
                            onChange={handleImageChange}
                          />
                        </div>
                        <span style={{ fontSize: "12px", color: "#d83030" }}>
                          Maximum Upload Limit: 5MB
                        </span>
                      </div>
                    </FormGroup>
                  </Col>
                </>
              )}
                <style>{`

.range-container {
 width: 60%;
 margin: 0 auto;
 text-align: center;
}

.range-label {
 font-size: 18px;
 margin-bottom: 10px;
}

input[type="range"] {
 -webkit-appearance: none;
 -moz-appearance: none;
 appearance: none;
 width: 100%;
 height: 12px;
 border-radius: 10px;
 background: linear-gradient(to right,rgb(255, 255, 255) 0%,rgb(255, 0, 0) 100%);
 outline: none;
 transition: background 0.3s ease;
}

input[type="range"]::-webkit-slider-thumb {
 -webkit-appearance: none;
 appearance: none;
 width: 20px;
 height: 20px;
 background: blue;
 border-radius: 50%;
 cursor: pointer;
 box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
}

input[type="range"]::-moz-range-thumb {
 width: 20px;
 height: 20px;
 background: #4caf50;
 border-radius: 50%;
 cursor: pointer;
 box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
}

          input[type="range"]:disabled {
   background: linear-gradient(to right, rgb(255, 255, 255) 0%, rgb(87, 87, 87) 100%);
 }
     input[type="range"]:disabled::-webkit-slider-thumb {
     background: gray;
     cursor: not-allowed;
   }

           
         `}</style>
            </Row>
            <div className="text-center d-flex justify-content-center mt-5 pt-3">
              <Button color="primary" type="submit">
              {loading ? <Spinner size="sm" /> : 'Save'}
              </Button>
              <Button
                className="btn-no-radius mx-2"
                color="secondary"
                onClick={handleCancel}
              >
                Cancel
              </Button>
            </div>
          </Card>
          : 
     <>
         <div >
         <Card
            className="p-4 "
            style={{
              boxShadow: "none",
              marginBottom: "10px",
              borderRadius: "0",
              height:'75vh',
            }}
          >
           <div className="text-center">
             <div className="mt-4">
               <h5>Please select a branch to configure the student certificate</h5>
             </div>
           </div>
           </Card>
         </div>
          </>
          }
        </Form>
      </div>
    </>
  );
}
